var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccountIconGreen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-green {\n        fill: #84bd00;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PEvW7o.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-green",
    d: "M12.75,0l1.29.17c5.13.88,9.2,5.11,9.84,10.28l.11,1.09c-.01.3.02.62,0,.92-.55,10.17-12.61,15.3-20.16,8.33C-3.88,13.66.8.63,11.22,0h1.53ZM18.27,20.89c4.86-3.41,6.07-10.16,2.7-15.08C16.61-.57,7.03-.43,2.84,6.05c-3.17,4.91-1.91,11.5,2.86,14.84v-2.83c0-1.71,1.78-3.43,3.37-3.78,1.1-.24,4.4-.24,5.53-.06,1.72.27,3.67,2.02,3.67,3.84v2.83ZM9.57,15.29c-3.18.59-2.86,3.62-2.8,6.14,0,.07.01.1.05.15.06.07.61.38.73.44,2.44,1.23,6.27,1.16,8.74.03.25-.11.87-.37.9-.63-.07-2.14.52-4.66-1.8-5.82-1.48-.74-4.16-.15-5.83-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-green",
    d: "M11.41,3.85c3.3-.34,5.86,2.6,4.95,5.82-1.1,3.92-6.55,4.44-8.43.84-1.45-2.78.33-6.34,3.47-6.66ZM11.62,4.92c-4.46.45-3.91,7.3.7,6.93s3.97-7.41-.7-6.93Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccountIconGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/account-icon-green.7faf9441502fca4a4d8e1c2785ddbf00.svg";